import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useInfiniteList as t, useInfiniteQuery as n } from "@maat/store-hooks";
import { adminSupportChatApi as r } from "@maat/api-chat";
//#region src/hooks/useAdminSupportMessagesQuery.ts
var i = 50, a = (a) => t(n({
	queryKey: e.adminSupportMessages(a ?? ""),
	queryFn: async ({ pageParam: e }) => r.getMessages(a, {
		limit: i,
		offset: e
	}),
	initialPageParam: 0,
	getNextPageParam: (e, t) => e.hasMore ? t.reduce((e, t) => e + t.messages.length, 0) : void 0,
	enabled: !!a
}), "messages");
//#endregion
export { a as useAdminSupportMessagesQuery };
